/* eslint-disable import/prefer-default-export */
import { TRACKING_KEY, TRACKING_EVENT } from 'shared/constants';

export const trackCompleteStep = (tracking, step) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.COMPLETE_FLOW,
    value: step,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};
